module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/fonts/fontawesome-webfont.eot
// module chunks = 2